import { 
    INE_DASHBOARD_START_LOADING, 
    INE_DASHBOARD_END_LOADING, 
    SET_INE_DASHBOARD_FILTER_SEARCH,
    SET_INE_DASHBOARD_FILTER_MINE_ONLY,
    INE_DASHBOARD_DRAFT_LOADED, 
    INE_DASHBOARD_NEW_LOADED,
    INE_DASHBOARD_PENDING_APPROVAL_LOADED,
    INE_DASHBOARD_REJECTED_LOADED,
    INE_DASHBOARD_SALES_ACTION_LOADED,
    INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED,
    INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED,
    INE_DASHBOARD_PERFORM_INSPECTION_LOADED,
    INE_DASHBOARD_AWAITING_SIGNATURE_LOADED,
    INE_DASHBOARD_COMPLETED_LOADED,
    INE_DASHBOARD_CLOSED_LOADED,
    INE_DASHBOARD_ABORTED_LOADED,
    INE_DASHBOARD_AREA_MANAGER_USER_LOADED,
    INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED,
    INE_DASHBOARD_INSPECTOR_USER_LOADED,
    INE_DASHBOARD_FINANCE_USER_LOADED,
    INE_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IneDashboardConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIneDashboard(status, search, mineOnly) {
    return async (dispatch) => {
        
        await dispatch({ type: INE_DASHBOARD_START_LOADING });

        try {

            var data = await getApiData("IneRequest/GetIneRequestGroupFBO", { status, search, mineOnly }, null);
            if(data.success) {
                if(status === null || status === "" || status === "Draft") {
                    await dispatch({
                        type: INE_DASHBOARD_DRAFT_LOADED,
                        payload: data.responseEntities[0].draftList
                    });
                }

                if(status === null || status === "" || status === "New") {
                    await dispatch({
                        type: INE_DASHBOARD_NEW_LOADED,
                        payload: data.responseEntities[0].newList
                    });
                }

                if(status === null || status === "" || status === "Pending Approval") {
                    await dispatch({
                        type: INE_DASHBOARD_PENDING_APPROVAL_LOADED,
                        payload: data.responseEntities[0].pendingApprovalList
                    });
                }

                if(status === null || status === "" || status === "Rejected") {
                    await dispatch({
                        type: INE_DASHBOARD_REJECTED_LOADED,
                        payload: data.responseEntities[0].rejectedList
                    });
                }

                if(status === null || status === "" || status === "Creat Quotation") {
                    await dispatch({
                        type: INE_DASHBOARD_SALES_ACTION_LOADED,
                        payload: data.responseEntities[0].salesActionList
                    });
                }

                if(status === null || status === "" || status === "PO Acknowledge") {
                    await dispatch({
                        type: INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED,
                        payload: data.responseEntities[0].approvalOfContractList
                    });
                }

                if(status === null || status === "" || status === "WOF Completion") {
                    await dispatch({
                        type: INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED,
                        payload: data.responseEntities[0].issueWorkOrderFormList
                    });
                }

                if(status === null || status === "" || status === "Inspection") {
                    await dispatch({
                        type: INE_DASHBOARD_PERFORM_INSPECTION_LOADED,
                        payload: data.responseEntities[0].performInspectionList
                    });
                }

                if(status === null || status === "" || status === "Awaiting Signature") {
                    await dispatch({
                        type: INE_DASHBOARD_AWAITING_SIGNATURE_LOADED,
                        payload: data.responseEntities[0].awaitingSignatureList
                    });
                }

                if(status === null || status === "" || status === "Create Invoice") {
                    await dispatch({
                        type: INE_DASHBOARD_COMPLETED_LOADED,
                        payload: data.responseEntities[0].completedList
                    });
                }

                if(status === null || status === "" || status === "Closed") {
                    await dispatch({
                        type: INE_DASHBOARD_CLOSED_LOADED,
                        payload: data.responseEntities[0].closedList
                    });
                }

                if(status === null || status === "" || status === "Aborted") {
                    await dispatch({
                        type: INE_DASHBOARD_ABORTED_LOADED,
                        payload: data.responseEntities[0].abortedList
                    });
                }

                await dispatch({
                    type: INE_DASHBOARD_AREA_MANAGER_USER_LOADED,
                    payload: data.responseEntities[0].areaManagerUserList
                });

                await dispatch({
                    type: INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED,
                    payload: data.responseEntities[0].technicalManagerUserList
                });

                await dispatch({
                    type: INE_DASHBOARD_INSPECTOR_USER_LOADED,
                    payload: data.responseEntities[0].inspectorUserList
                });

                await dispatch({
                    type: INE_DASHBOARD_FINANCE_USER_LOADED,
                    payload: data.responseEntities[0].financeUserList
                });

                await dispatch({
                    type: INE_DASHBOARD_USER_SEARCH_LOADED,
                    payload: data.responseEntities[0].userSearches
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: INE_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_DASHBOARD_END_LOADING });
        }
    };
}

export function setIneDashboardFilterSearch(search) {
    return async (dispatch) => {
        await dispatch({
            type: SET_INE_DASHBOARD_FILTER_SEARCH,
            payload: search
        });
    };
}

export function setIneDashboardFilterMineOnly(mineOnly) {
    return async (dispatch) => {
        await dispatch({
            type: SET_INE_DASHBOARD_FILTER_MINE_ONLY,
            payload: mineOnly
        });
    };
}

export function assignIneRequest(ineRequestId, userId, assignMe, items, index) {
    return async (dispatch) => {
        
        await dispatch({ type: INE_DASHBOARD_START_LOADING });

        try {

            var data = await postApiJsonData("IneRequest/AssignIneRequest", { ineRequestId, userId, assignMe }, null);
            
            if(data.success) {
                if(data.responseEntities[0].status === "Draft") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_DRAFT_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "New") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_NEW_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Sales Action") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_SALES_ACTION_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Approval Of Contract") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Issue Work Order Form") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Perform Inspection") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_PERFORM_INSPECTION_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Awaiting Signature") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_AWAITING_SIGNATURE_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Completed") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_COMPLETED_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Closed") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_CLOSED_LOADED,
                        payload: items
                    });
                }
                else if(data.responseEntities[0].status === "Aborted") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: INE_DASHBOARD_ABORTED_LOADED,
                        payload: items
                    });
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: INE_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_DASHBOARD_END_LOADING });
        }
    };
}
